import '@bn-games/ui-shell/social.css';
import { mountInviteDock, type InviteDockHandle } from '@bn-games/ui-shell/social';
import { ensureI18n, type LandingLocale } from './i18n/I18n.js';
import { lobbyServerUrl } from './pages/FriendsPresence.js';

let dock: InviteDockHandle | null = null;

/**
 * Mounts the pending-invite dock for the page's lifetime. Imports only the
 * `ui-shell/social` subpath: the root barrel would make this app's `tsc` owe
 * every game-menu key. Call it from a page's runtime bootstrap, never at
 * module top level, since the dock touches `document` and the home page is
 * prerendered.
 *
 * `locale` only matters on pages that haven't already run `initI18n`; the
 * untranslated pages pass nothing and get English, matching their own copy.
 */
export async function mountLandingInviteDock(locale: LandingLocale = 'en'): Promise<InviteDockHandle> {
  await ensureI18n(locale);
  if (dock === null) {
    dock = mountInviteDock({ serverUrl: lobbyServerUrl(), density: 'expanded' });
  }
  return dock;
}
